import type { ComponentProps } from "react";
import { Link } from "react-router-dom";
import { t } from "ttag";

import { ROUTES } from "@/app/router";
import { FullscreenAlert, HeartsIcon } from "@/shared/ui";

export const PaymentSucceededFullscreenAlert = (
  props: ComponentProps<typeof FullscreenAlert.Root>,
) => {
  return (
    <FullscreenAlert.Root {...props}>
      <FullscreenAlert.Content>
        <FullscreenAlert.Header icon={HeartsIcon}>
          <FullscreenAlert.Title>
            {t`Payment successfully processed!`}
          </FullscreenAlert.Title>
          <FullscreenAlert.Description>
            {t`Your payment has been processed correctly. Please complete the intake form to be able to join video consultations or order medication.`}
          </FullscreenAlert.Description>
        </FullscreenAlert.Header>

        <FullscreenAlert.Footer>
          <FullscreenAlert.Cancel asChild>
            <Link to={ROUTES.BILLING.OVERVIEW} replace>{t`Close`}</Link>
          </FullscreenAlert.Cancel>
          <FullscreenAlert.Action asChild>
            <Link to={ROUTES.HOME} replace>{t`Go to Home`}</Link>
          </FullscreenAlert.Action>
        </FullscreenAlert.Footer>
      </FullscreenAlert.Content>
    </FullscreenAlert.Root>
  );
};
